export const amexTheme = {
  globals: {
    name: 'Amex',
    fontFamily: '"Open Sans", sans-serif',
    fontFamilyHeadline: '"Open Sans", sans-serif',
    fontFamilyBold: '"Open Sans", sans-serif',
    bgColor: 'rgba(247, 248, 249, 1)',
    linkColor: 'rgba(0, 111, 207, 1)',
    linkColorHover: 'rgba(16, 104, 165, 1)',
    checkboxColor: 'rgba(0, 111, 207)',
    checkboxColorActive: 'rgba(0, 111, 207)',
    inputRequired: {
      asteriskColor: 'rgb(255, 68, 68)',
      textColor: 'rgb(255, 68, 68)',
      textFontSize: '14px',
    },
  },
  contentWrap: {},
  container: {
    bgColor: '#FFFFFF',
    width: '100%',
    padding: '60px 80px 60px',
    borderRadius: '0px',
    border: 'none',
    boxShadow: 'none',
    margin: '0 auto',
    color: '#505050',
  },
  documentCheckbox: {
    iconColor: 'rgba(0, 111, 207, 1)',
    iconHover: 'rgba(0, 111, 207, 0.6)',
    width: '100%',
    contentFontSize: '14px',
    margin: '20px',
  },
  icon: {
    docVerifyDotsColor: 'rgba(255, 255, 255, 1)',
    mainIconColor: 'rgba(0, 111, 207, 1)',
    colorHover: 'rgba(0, 111, 207, 1)',
    size: '32px',
    thickness: '0.2px',
  },
  otpInput: {
    width: '100%',
    columnGap: '10px',
    marginTop: '10px',
    marginBottom: '30px',
    inputHeight: '60px',
    inputBorder: '1px solid rgba(200, 201, 199, 1)',
    borderRadius: '8px',
    fontSize: '28px',
    focusColor: 'rgba(0, 111, 207, 1)',
    bgColor: 'rgba(247, 248, 249, 1)',
    focusBgColor: 'rgba(247, 248, 249, 1)',
    fontColor: '#000000',
    loadingColor: 'rgba(0, 111, 207, 1)',
  },
  pdfViewer: {
    pageBackground: '#FFFFFF',
    containerBorder: '1px solid rgba(235, 235, 235, 1)',
    scrollTrackColor: '#F1F3F7',
    scrollHandleColor: '#000000',
    scrollRadius: '0px',
    toolbox: {
      color: '#FFFFFF',
      bgColor: 'rgba(0, 0, 0, 0.70)',
      borderRadius: '4px',
      padding: '5px',
      boxShadow: '#none',
    },
    zoomButton: {
      bgColor: '#FFFFFF',
      color: '#000000',
      border: '1px solid #CECBD6',
      bgColorHover: '#F1F3F7',
      colorHover: '#000000',
      borderHover: '1px solid #CECBD6',
    },
    pageRangeInput: {
      trackColor: '#CECBD6',
      activeTrackColor: '#000000',
      thumbColor: '#000000',
      thumbHoverColor: '#000000CC',
      thumbFocusBorderColor: '',
    },
  },
  downloadDocumentButton: {
    bgColor: '#FFFFFF',
    color: '#000000',
    borderColor: '#CECBD6',
    bgColorHover: '#F1F3F7',
    colorHover: '#000000',
    borderColorHover: '#CECBD6',
    bgColorDisabled: '#F6F6F6',
    colorDisabled: '#91969B',
    borderColorDisabled: '#F6F6F6',
  },
  button: {
    bgColor: 'rgba(0, 111, 207, 1)',
    padding: '12px 36px',
    borderRadius: '4px',
    width: 'auto',
    border: '1px solid rgba(0, 111, 207, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(255, 255, 255, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(16, 104, 165, 1)',
    borderHover: '1px solid rgba(16, 104, 165, 0.6)',
    bgColorDisabled: 'rgba(0, 111, 207, 1)',
    borderDisabled: '1px solid rgba(0, 111, 207, 1)',
    colorDisabled: 'rgba(255, 255, 255, 1)',
    fontSize: '13px',
    fontWeight: '600',
  },
  buttonSecondary: {
    bgColor: 'transparent',
    padding: '12px 36px',
    borderRadius: '4px',
    width: 'auto',
    border: '1px solid #DCDBE2',
    boxShadow: 'none',
    margin: '0',
    color: '#34353A',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(16, 104, 165, 1)',
    borderHover: '1px solid rgba(16, 104, 165, 0.6)',
    bgColorDisabled: 'rgba(0, 111, 207, 1)',
    borderDisabled: '1px solid rgba(0, 111, 207, 1)',
    colorDisabled: 'rgba(255, 255, 255, 1)',
    fontSize: '13px',
    fontWeight: '600',
  },
  buttonDisabled: {
    bgColor: 'rgba(0, 111, 207, 1)',
    padding: '12px 36px',
    borderRadius: '4px',
    width: 'auto',
    border: '1px solid rgba(0, 111, 207, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(255, 255, 255, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(0, 111, 207, 1)',
    borderHover: '1px solid rgba(0, 111, 207, 1)',
    fontSize: '13px',
    fontWeight: '600',
  },
  header: {
    color: '#505050',
    fontSize: '1.625rem',
    lineHeight: '2.25rem',
    fontSizeMobile: '1.25rem',
    lineHeightMobile: '1.9375rem',
    margin: '15px 0',
    textAlign: 'center',
    width: '100%',
  },
  selectInput: {
    borderRadius: '8',
    borderWidth: '1px',
    borderColorFocus: 'rgba(0, 111, 207, 0.65)',
    colorSelected: 'rgba(242, 248, 255, 1)',
    backgroundColorSelected: 'rgba(0, 111, 207, 0.65)',
    backgroundColorFocus: 'rgba(0, 111, 207, 0.25)',
    currentBg: 'rgba(0, 111, 207, 0.15)',
    indicatorColorFocus: 'rgb(102, 102, 102)',
    indicatorColorHover: 'rgb(153, 153, 153)',
    danger: 'rgba(226,64,40,1)',
    dangerLight: 'rgba(226,64,40,0.5)',
  },
  symbol: {
    primary: 'rgba(0, 111, 207, 1)',
    secondary: 'rgba(255, 255, 255, 1)',
    tenary: 'rgba(247, 248, 249, 1)',
  },
  textInput: {
    bgColor: 'rgba(247, 248, 249, 1)',
    padding: '14px',
    borderRadius: '4px',
    border: '1px solid rgba(200, 201, 199, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'black',
    colorFocus: 'black',
    bgColorFocus: 'rgba(247, 248, 249, 1)',
    borderFocus: '1px solid rgba(200, 201, 199, 1)',
    bgColorDisabled: 'silver',
    borderDisabled: 'gray',
    colorDisabled: 'white',
    fontSize: '14px',
    fontWeight: '400',
    outline: '1px solid rgba(0, 111, 207, 1)',
    errorColor: '#d91111',
  },
  brandBar: {
    bgColor: 'white',
    padding: '30px',
    margin: '0 0 30px 0',
    border: 'none',
    boxShadow: 'none',
    justifyContent: 'normal',
  },
  wrapXs2a: {
    fontFamily: '"Open Sans", sans-serif',
    fontFamilyHeadline: '"Open Sans", sans-serif',
    bgColor: '#FFFFFF',
    linkColor: 'rgba(0, 111, 207, 1)',
    linkColorHover: 'rgba(0, 111, 207, 1)',
    checkboxColor: 'rgba(0, 111, 207, 1)',
    checkboxColorActive: 'rgba(0, 111, 207, 1)',
    backButton: {
      borderColor: 'rgba(247, 248, 249, 1)',
      color: 'black',
      colorHover: 'black',
      disabled: 'silver',
    },
    input: {
      bgColor: 'rgba(247, 248, 249, 1)',
      padding: '14px',
      borderRadius: '4px',
      border: '1px solid rgba(200, 201, 199, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'black',
      colorFocus: 'black',
      bgColorFocus: 'rgba(247, 248, 249, 1)',
      borderFocus: '1px solid rgba(200, 201, 199, 1)',
      bgColorDisabled: 'silver',
      borderDisabled: 'gray',
      colorDisabled: 'white',
      fontSize: '14px',
      fontWeight: '400',
      outline: '1px solid rgba(0, 111, 207, 1)',
      errorColor: '#d91111',
    },
    button: {
      bgColor: 'rgba(0, 111, 207, 1)',
      padding: '12px 36px',
      borderRadius: '4px',
      width: 'auto',
      border: '1px solid rgba(0, 111, 207, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'rgba(255, 255, 255, 1)',
      colorHover: 'rgba(255, 255, 255, 1)',
      bgColorHover: 'rgba(16, 104, 165, 1)',
      borderHover: '1px solid rgba(16, 104, 165, 0.6)',
      bgColorDisabled: 'rgba(0, 111, 207, 1)',
      borderDisabled: '1px solid rgba(0, 111, 207, 1)',
      colorDisabled: 'rgba(255, 255, 255, 1)',
      fontSize: '13px',
      fontWeight: '600',
    },
  },
  wrapKlarna: {
    bgColor: 'rgba(235, 235, 235, 1)',
  },
  wrapKontomatik: {
    bgColor: '#FFF',
    textColor: 'rgba(0, 0, 0, 1)',
    borderColor: 'rgba(28, 105, 212, 1)',
    headerColor: '#505050',
    primaryColor: 'rgba(0, 101, 131, 1)',
    primaryReverseColor: '#FFF',
    secondaryColor: '#586374',
    mainHoverColor: 'rgb(16, 104, 165)',
    mainHoverReverseColor: '#FFF',
    listHoverColor: '#F5F5F5',
    disabledColor: '#CED4DA',
    errorColor: '#BB0000',
    width: '100%',
    padding: '60px 80px 60px',
    borderRadius: '0px',
    border: 'none',
    boxShadow: 'none',
    margin: '0 auto',
  },
  progressBar: {
    time: 180,
    secondChance: true,
    showCounter: true,
    height: '18px',
    margin: '40px 0 10px 0',
    padding: '0 20px',
    border: '1px solid rgba(220, 220, 220, 1)',
    borderRadius: '18px',
    background: 'white',
    barFill:
      'linear-gradient(90deg, rgba(0, 111, 207,0) 0%, rgba(0, 111, 207,1) 100%)',
    counterMargin: '20px 0',
    counterPadding: '0',
    counterFontSize: '24px',
    counterColor: 'rgba(0, 111, 207, 1)',
    infoMessageTextAlign: 'center',
    infoMessageFontSize: '12px',
    infoMessageMargin: '6px 0 0 0',
  },
  stepper: {
    borderColor: 'rgba(200, 201, 199, 1)',
    fontSizeTitle: '12px',
    fontSizeDesc: '10px',
  },
  loadingSpinner: {
    primary: 'rgba(0, 111, 207, 1)',
    bgColor: 'rgba(235, 235, 235, 1)',
  },
  tabSwitcher: {
    borderBottom: '2px solid #dbdbdb',
    buttonColor: '#9b9b9b',
    buttonBorderBottom: '4px solid rgba(0, 111, 207, 1)',
    buttonColorActive: '#000',
  },
  errorPage: {
    title: {
      color: '#505050',
    },
    subtitle: {
      color: '#98959f',
    },
    svg: {
      fill1: 'none',
      fill2: '#ffffff',
      fill3: '#000',
      fill4: 'rgba(0, 111, 207, 1)',
    },
  },
  popup: {
    clickOutsideEnabled: true,
  },
  videoIdCallToActionButton: {
    bgColor: 'rgba(0, 111, 207, 1)',
    padding: '10px 34px 10px 34px',
    borderRadius: '2px',
    width: '150px',
    border: '1px solid rgba(0, 111, 207, 1)',
    boxShadow: 'none',
    margin: '32px 0 0 0',
    color: 'rgba(255, 255, 255, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(16, 104, 165, 1)',
    borderHover: '1px solid rgba(16, 104, 165, 0.6)',
    bgColorDisabled: 'rgba(0, 111, 207, 1)',
    borderDisabled: '1px solid rgba(0, 111, 207, 1)',
    colorDisabled: 'rgba(255, 255, 255, 1)',
    fontSize: '18px',
    fontWeight: '700',
    textDecoration: 'none',
  },
  videoIdPhoneChangeButton: {
    color: '#006ECF',
  },
}
